module.exports = __webpack_public_path__ + "static/media/spinner.2c05eb48.gif";